/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useEffect } from 'react';
import IconChevronLeft from '@zvuk-b2b/react-uikit/ui/icons/ChevronLeft';
import IconButton from '@zvuk-b2b/react-uikit/ui/IconButton';
import useMedia from '@zvuk-b2b/react-uikit/toolkit/useMedia';
import { VideoPreview } from './VideoPreview';

import styles from './index.module.scss';
import { ImagePreview } from './ImagePreview';

interface IVideoMediafilePreview {
  url: string;
  isVideo: boolean;
  onClose: () => void;
}

export const VideoMediafilePreview: React.FC<IVideoMediafilePreview> = ({ url, isVideo, onClose }) => {
  const { isMobile } = useMedia();

  useEffect(() => {
    const handleEscKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };
    document.addEventListener('keydown', handleEscKey);

    return () => {
      document.removeEventListener('keydown', handleEscKey);
    };
  }, []);

  return (
    <div>
      <div className={styles.layout}>
        {isMobile && (
          <IconButton
            onClick={onClose}
            className={styles.chevronLeft}
            elementId="mobile_preview_back">
            <IconChevronLeft />
          </IconButton>
        )}
        {isVideo && <VideoPreview url={url} />}
        {!isVideo && <ImagePreview url={url} />}
        <div
          className={styles.overlay}
          onClick={onClose}
        />
      </div>
    </div>
  );
};
